<template functional>
    <div class="event-summary__event-media">
        <div
            v-if="props.liveVideo"
            class="event-summary__event-media-icon"
        >
            <Icon
                v-tooltip="parent.$t('Live video stream avaliable')"
                size="sm"
                class="icon-live_stream"
            />
        </div>
        <div
            v-if="props.broadcast"
            class="event-summary__event-media-icon"
        >
            <div class="broadcasts">
                <div class="brodacst__header">
                    <span>{{ parent.$t('Watch match on TV') }}</span>
                </div>
                <div
                    v-for="(channel, index) in props.broadcast"
                    class="broadcasts__item"
                    :key="index"
                >
                    <div class="broadcasts__item-image">
                        <img
                            :src="channel.iconUrl"
                            :alt="channel.name"
                        />
                    </div>
                    <span class="broadcasts__item-text">
                        {{ channel.name }}
                    </span>
                </div>
            </div>
            <Icon
                size="sm"
                class="actionable icon-tv"
            />
        </div>
    </div>
</template>

<script>
    export default {
        functional: true,
        props: {
            liveVideo: {
                type: Boolean,
                required: false,
                default: false,
            },
            broadcast: {
                type: Object,
                default: null,
            },
        },
    };
</script>
